<template>
  <v-app
    id="login"
    class="grey darken-4"
  >
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <slot />
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  name: 'CoopermaisAuth'
}
</script>
